module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "duplicateMovementsAnalysis"
    }
  }, [_c('confirm-modal', {
    attrs: {
      "id": "confirmUpdateAnnulledField"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.labelConfirmacaoAnulacao)
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('analiseDuplicidade.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalUpdateAnulledField",
      "clickFunction": _vm.annulMovementsCloseModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('analiseDuplicidade.labels.sim'),
      "id": "btnConfirmacaoModalUpdateAnulledField",
      "clickFunction": _vm.annulMovements,
      "disabled": _vm.disableConfirmButton
    }
  })], 1)]), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('analiseDuplicidade.titulos.titulo'),
      "subTitle": _vm.$t('analiseDuplicidade.titulos.subtitulo')
    }
  }), _c('div', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('vue-tabs', {
    attrs: {
      "id": "tab-navigation"
    },
    on: {
      "tab-change": _vm.handleTabChange
    }
  }, [_c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-analise-duplicados",
      "title": _vm.$t('analiseDuplicidade.labels.listaDuplicado')
    }
  }, [(_vm.currentTab === 'tabDuplicated') ? _c('duplicate-movements', {
    attrs: {
      "disableSearchButton": _vm.disableSearchButton
    },
    on: {
      "search-movements": _vm.searchMovements
    }
  }) : _vm._e()], 1), _c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-analise-anulados",
      "title": _vm.$t('analiseDuplicidade.labels.listaAnulado')
    }
  }, [(_vm.currentTab === 'tabAnnulled') ? _c('annulled-movements', {
    attrs: {
      "disableSearchButton": _vm.disableSearchButton
    },
    on: {
      "search-movements": _vm.searchMovements
    }
  }) : _vm._e()], 1)], 1)], 1), (_vm.showTreegrid) ? _c('div', [_c('tree-grid', {
    attrs: {
      "gridId": _vm.searchData.gridId,
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "AnaliseDuplicidade",
      "treeGridLayoutPath": "duplicateMovements",
      "cfgObj": _vm.treeGridCfg,
      "showAnnulledMovementButton": true,
      "showAlert": true,
      "alertMessage": _vm.labelAlertaAnulacao
    },
    on: {
      "annulMovements": _vm.annulMovementsOpenModalConfirm
    }
  })], 1) : _vm._e()], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-385bbd4c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-385bbd4c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/reports/duplicateMovementsAnalysis/duplicateMovementsAnalysis.pug
// module id = 1399
// module chunks = 0